import { useEffect } from 'react';
import { connect } from '@app/decorators/connect';

const enhance = connect(({ authStore, routerStore }) => ({
    onMount: () => authStore.loginAs(routerStore.query.t),
}));

function LoginAsPage({ onMount }) {
    useEffect(() => {
        onMount();
    }, []);
    return null;
}

export default enhance(LoginAsPage);
